import { apolloClientPublic } from 'front-end/src/graphql/apolloClient'
import { transitionAppStateToLoggedOut } from 'front-end/src/pages/auth/SessionHelpers'
import { useLogoutMutation } from './useLogout.codegen'
import ReactDOM from 'react-dom'
import { getRootLooopAppDOMElement } from 'front-end/src/components/utils/rootElResolver'

export function useLogout() {
  const [logout] = useLogoutMutation({
    client: apolloClientPublic
  })

  return (hrefAfterLogout?: string) => {
    ReactDOM.unmountComponentAtNode(getRootLooopAppDOMElement()) // this will prevent our react tree from refreshing all the GQL queries currently rendered
    setTimeout(async () => {
      // for some strange reason when we didn't use setTimeout, apollo was still able to fire off a refetch, even though it should be unmounted by now
      await logout()

      await transitionAppStateToLoggedOut()

      if (typeof hrefAfterLogout === 'string') {
        /**
         * This branch is used if there is need to redirect after logout. Like in case when login as someone else or if there is requiremtn to logout from external SSO provider
         */
        window.location.href = hrefAfterLogout
      } else {
        const { renderLooopApp } = await import(
          'front-end/src/components/LooopApp'
        )
        renderLooopApp()
      }
    })
  }
}
